<script setup>
import { onMounted, ref, computed } from 'vue'
import { abuseReportReasonsGet } from '@/api/api.js'
import reportModalState from '@/components/ModalsNext/ReportModal/Store/report-modal-state.js'
import { useTimeout } from '@vueuse/core'
import app from '@/main.js'

const items = ref([])
const loading = ref(false)
const { ready, start, stop } = useTimeout(600, { controls: true, immediate: false })

const isLoading = computed(() => {
  return loading.value || !ready.value
})

const {
  selectedReason,
  errorMessage
} = reportModalState

onMounted(async () => {
  try {
    start()
    const { data } = await abuseReportReasonsGet()

    items.value = data.abuseReportReasons
  } catch (error) {
    stop()
    errorMessage.value = 'Failed to load report reasons. Please try again later.'
    console.error('Error fetching abuse report reasons:', error)
  } finally {
    loading.value = false
  }
})

function randomWidthClass () {
  const classes = [
    'w-24',
    'w-28',
    'w-32',
    'w-36',
    'w-40',
    'w-44'
  ]

  return classes[Math.floor(Math.random() * classes.length)]
}
</script>

<template>
  <fieldset class="mb-5">
    <legend class="mb-3">{{ app.$i18n.t('report.select_reason') }}</legend>

    <div
      v-show="isLoading"
      class="space-y-3">
      <div
        v-for="_ in 17"
        :key="_"
        class="flex items-center gap-2 h-6">
        <div class="rounded-full skeleton-loading w-4 h-4"/>

        <div
          :class="randomWidthClass()"
          class="h-3 rounded-full skeleton-loading"/>
      </div>
    </div>

    <div class="space-y-3">
      <div
        v-for="item in items"
        v-show="!isLoading"
        :key="item.id"
        class="flex gap-2">
        <div class="flex h-6 shrink-0 items-center">
          <input
            :id="item.title + item.id"
            v-model="selectedReason"
            :value="item.id"
            type="radio"
            :name="item.title"
            :aria-describedby="'Reason to report is: ' + item.description"
            class="h-4 w-4 rounded-full border-gray-300 accent-primary focus:ring-primary text-primary focus:text-primary" >
        </div>

        <div class="text-sm/6">
          <label
            :for="item.title + item.id"
            class="font-medium text-gray-900">{{ item.title }}</label>
        </div>
      </div>
    </div>
  </fieldset>
</template>